import React from 'react';

import Avatar from '@material-ui/core/Avatar';
import Chip from '@material-ui/core/Chip';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';

import indigo from '@material-ui/core/colors/indigo';
import orange from '@material-ui/core/colors/orange';

const styles = theme => ({
  root: {
    height: '50px',
    display: 'flex',
    alignItems: 'center',
  },
  left: {
    flex: 1,
    display: 'flex',
    justifyContent: 'center',
  },
  center: {
    flex: 1,
    display: 'flex',
    justifyContent: 'center'
  },
  right: {
    flex: 1,
    display: 'flex',
    justifyContent: 'flex-end',
    paddingRight: '15px',
  },
  maintenanceAvatar: {
    color: '#fff',
    backgroundColor: indigo[500]
  },
  projectAvatar: {
    color: '#fff',
    backgroundColor: orange[500]
  },
});

const ProjectHeader = ({ classes, project }) => {
  return(
    <div className={classes.root}>
      <div className={classes.left}/>
      <Typography variant="title" className={classes.center}>
        {`${project.jobCode}`}
      </Typography>
      <div className={classes.right}>
        <Chip
          avatar={<Avatar className={project.isRecurring ? classes.maintenanceAvatar : classes.projectAvatar}>{project.isRecurring ? "M" : "P"}</Avatar>}
          label={
            project.isRecurring
              ? <Typography variant="subheading">Maintenance</Typography>
              : "Project"
          }
        />
      </div>
    </div>
  );
};

export default withStyles(styles)(ProjectHeader);



// WEBPACK FOOTER //
// ./src/components/admin/Project/ProjectHeader.jsx